import { findModule } from '../modules'

import type { FeedbackPageContext } from './types'

const LOCAL_BUILD_ID = 'lokal'

/** Liest den Kontext genau in dem Moment, in dem der Nutzer Feedback startet. */
export function collectFeedbackPageContext(): FeedbackPageContext {
  const pathSegment = window.location.pathname.split('/').filter(Boolean)[0]
  const module = pathSegment ? findModule(decodeURIComponent(pathSegment)) : undefined
  const heading = document.querySelector('main h1')?.textContent?.trim()

  return {
    seitenPfad: `${window.location.pathname}${window.location.search}${window.location.hash}`,
    modulId: module?.id ?? null,
    modulTitel: module?.title ?? null,
    seitentitel: heading || module?.title || document.title || 'Berky Digital',
    buildId: import.meta.env.VITE_BERKY_BUILD_ID?.trim() || LOCAL_BUILD_ID,
  }
}
